/**
 * module for handleing events
 */
import _ from 'lodash';
import * as Mutations from '../mutation-types';


const state = {
  selectedEventId: [],
  selectedEvent: {},
  currentEvent: {},
  currentEventIndex: 0,
  nextEvent: null,
  nextEventId: null,
  eventPayload: '',
  events: [],
  backupEvents: [],
  medRecordNo: undefined,
};

const mutations = {
  /**
   * reset event state.
   * @param {*} state veux.state
   */
  [Mutations.RESET_EVENT_MODULE](state) {
    state.selectedEventId = [];
    state.selectedEvent = {};
    state.currentEvent = {};
    state.nextEvent = {};
    state.nextEventId = '';
    state.eventPayload = '';
    state.events = [];
    state.backupEvents = [];
    state.medRecordNo = undefined;
  },
  /**
   * set cuurrent event and next event
   * @param {*} state vuex state
   * @param {*} eventId event object id
   */
  [Mutations.SET_CURRENT_EVENT](state, eventId) {
    state.currentEvent = state.selectedEvent[eventId];
    // set next event
    const thisIndex = state.selectedEventId.indexOf(eventId);
    state.currentEventIndex = thisIndex;
    if ((thisIndex + 1) !== state.selectedEventId.length) {
      state.nextEventId = state.selectedEventId[thisIndex + 1];
      state.nextEvent = state.selectedEvent[state.nextEventId];
    } else {
      state.nextEvent = null;
      state.nextEventId = undefined;
    }
  },
  [Mutations.FILTER_EVENTS](state, searchText) {
    if (searchText !== '') {
      state.events = _.filter(state.backupEvents, (item) => {
        const hasGenericName = item.medication.generic_name.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
        const hasCGMHNumber = item.medication.CGMH_number.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
        const hasCode = item.medication.code.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
        return hasGenericName || hasCGMHNumber || hasCode;
      });
    } else {
      state.events = state.backupEvents;
    }
  },
  [Mutations.SET_MED_RECORD_NO](state, val) {
    state.medRecordNo = val;
  },
};

const actions = {
  unSelectAllEvent({ state }) {
    state.selectedEventId = [];
    state.selectedEvent = {};
  },
  /**
   * select event with given id.
   * @param {*} param0 vuex attribute
   * @param {*} eventId event object id
   */
  async selectEvent({ state, rootState }, payload) {
    console.log(payload);
    if (payload.singleSelection) {
      state.events.forEach((event) => {
        event.selected = false;
      });
      state.selectedEvent = {};
      state.selectedEventId = [];
    }

    const index = state.selectedEventId.indexOf(payload.eventId.toString());
    state.events.forEach((event) => {
      if (event.id === payload.eventId) event.selected = !event.selected;
    });

    if (index !== -1) {
      state.selectedEventId.splice(index, 1);
      delete state.selectedEvent[payload.eventId];
    } else {
      // add id
      state.selectedEventId.push(payload.eventId);
      // add event
      console.log(payload.eventId);
      await rootState.instance.get(`/api/event/${payload.eventId}/`)
      .then((res) => {
        const data = res.data;
        state.selectedEvent[payload.eventId] = res.data;
        state.selectedEventId = Object.keys(state.selectedEvent);
      });
    }
  },
  /**
   * query event api with given payload, ex: checked=True, ...
   * @param {*} param0 vuex attribute
   * @param {*} eventPayload payload for query
   */
  getEvents({ commit, rootState }, eventPayload) {
    state.eventPayload = eventPayload;
    return rootState.instance.get('/api/event/', {
      params: eventPayload,
    })
    .then((res) => {
      // create "selected" attribute for css.
      const data = res.data.results;
      data.forEach((element) => {
        element.selected = false;
      });
      state.events = data;
      state.backupEvents = data;
    });
  },
  /**
   * use event Id to set current drugStorage and current device.
   * @param {*} param0 vuex attribute
   * @param {*} eventId event object id
   */
  setCurrentEvent({ commit, dispatch, state }, eventId) {
    const event = state.selectedEvent[eventId];
    console.log(event);
    commit('SET_CURRENT_EVENT', eventId);
    dispatch('setDrug', event.medication.id);
    commit('SET_CURRENT_DEVICE_FROM_ALL', parseInt(event.device.id, 10));
    commit('SELECT_DRUG_IN_DEVICES_FROM_ALL', event.drug_storage);
    if (state.nextEventId) {
      commit('SET_NEXT_DEVICE', state.selectedEvent[state.nextEventId].device.id);
      commit('SET_NEXT_DRUG_IN_DEVICE', state.selectedEvent[state.nextEventId].drug_storage);
    } else {
      commit('REMOVE_NEXT_DEVICE');
      commit('REMOVE_NEXT_DRUG_IN_DEVICE');
    }
  },
  fromFirstEvent({ commit, dispatch, state }) {
    const firstEventId = state.selectedEventId[0];
    dispatch('setCurrentEvent', firstEventId);
  },
  /**
   * set next event and its drugStorage and device
   * @param {*} param0 vuex attribute
   */
  async toNextEvent({ commit, dispatch, state }) {
    dispatch('setCurrentEvent', state.nextEventId);
  },
  refineSelectedEvents({ commit, state }) {
    const uniqueDeviceIds = {};
    const refineEvents = {};
    Object.values(state.selectedEvent).forEach((event) => {
      if (uniqueDeviceIds[event.device.id]) {
        const eventId = uniqueDeviceIds[event.device.id];
        refineEvents[eventId].sameDeviceEvent.push(event);
        // accumulate `number1`;
        refineEvents[eventId].number1 += event.number1;
      } else {
        refineEvents[event.id] = event;
        refineEvents[event.id].sameDeviceEvent = [];
        refineEvents[event.id].sameDeviceEvent.push(event); // push self in.
        uniqueDeviceIds[event.device.id] = event.id;
      }
    });
    state.selectEvent = refineEvents;
    state.selectedEventId = Object.keys(refineEvents);
  },
  selectAllEventItems({ state }) {
    state.events.forEach((event) => {
      event.selected = true;
      state.selectedEventId.push(event.id);
      state.selectedEvent[event.id] = event;
    });
  },
  unSelectAllEventItems({ state }) {
    state.selectedEventId = [];
    state.selectedEvent = {};
    state.events.forEach((event) => {
      if (event.selected) {
        event.selected = false;
      }
    });
  },
  recordAction({ state, rootState, getters }, payload) {
    // const drugStorageId = (getters.currentDrugInDevice !== null ? getters.currentDrugInDevice.id : null);
    const drugStorageId = rootState.drugInDevice.currentDrugInDevice !== null ? rootState.drugInDevice.currentDrugInDevice.id : undefined;
    const number2 = payload.number2 ? payload.number2 : undefined;
    const number1 = payload.number1 ? payload.number1 : undefined;
    return rootState.instance.post('/api/event/', {
      drugStorage: drugStorageId,
      employee: rootState.user.user.id,
      event_type: payload.eventType,
      number1,
      number2,
      med_record_no: state.medRecordNo,
      system: rootState.device.systemId,
    });
  },
};

const store = {
  state,
  mutations,
  actions,
};

export default store;



// WEBPACK FOOTER //
// ./src/vuex/module/event.js